import React, { Component } from "react";

import axios from '@app/lib/axios';
import { Button } from "react-bootstrap";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast, Slide } from "react-toastify";

import * as Constant from "../../../Constant.js";

import RouteTitle from "../../../components/RouteTitle";
import DeviceSearchConfig from "./Components/DeviceSearchConfig";
import DeviceBooksParentTable from "./Components/DeviceBooksParentTable";

import "./search.css";
class SearchDeviceBooksParent extends Component {
    constructor(props) {
        const userType = localStorage.getItem("login_user_type") || "admin";
        const branchId = userType === "branch" ? localStorage.getItem("login_branch_id") || 0 : 0;
        super(props);
        this.state = {
            branchId: branchId,
            branches: null,
            nurseries: null,
            devices: null,
            isSearchReady: false,
            searchType: null,
            searchKeyword: null,
            selectedBranch: null,
            selectedNursery: null,
            selectedDevice: null,
        };
    }

    getBranchList = () => {
        axios({
            method: "get",
            url: Constant.API_DOMAIN + "/api/branch/list/YN",
        })
            .then((result) => {
                if (result.data.code === 200) {
                    var sortedBranches =
                        result.data.branches == null
                            ? null
                            : result.data.branches.sort(function (a, b) {
                                  if (a.name < b.name) {
                                      return -1;
                                  }
                                  if (a.name > b.name) {
                                      return 1;
                                  }
                                  if (a.use_yn > b.use_yn) {
                                      return -1;
                                  }
                                  if (a.use_yn < b.use_yn) {
                                      return 1;
                                  }
                                  return 0;
                              });
                    if (this.state.branchId > 0) {
                        let selectedBranch = sortedBranches.find((b) => b.id === parseInt(this.state.branchId));
                        this.setState({ branches: sortedBranches, selectedBranch: selectedBranch, isSearchReady: true });
                    } else {
                        this.setState({ branches: sortedBranches, isSearchReady: true });
                    }
                } else {
                    console.log(result);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    getNurseryList = (branchId) => {
        const userType = localStorage.getItem("login_user_type") || "admin";
        let url = Constant.API_DOMAIN + `/api/device/nursery/list/${userType}/${branchId}`;
        axios({
            method: "get",
            url: url,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    result.data.nurseries.sort((a, b) => {
                        if ( a.name < b.name ){
                            return -1;
                          }
                          if ( a.name > b.name ){
                            return 1;
                          }
                          return 0;
                    });
                    console.debug(result.data.nurseries);
                    this.setState({ nurseries: result.data.nurseries, isSearchReady: true });
                } else {
                    console.log(result);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                }
            })
            .catch((error) => {
                console.log(error);
                console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
            });
    };

    getDeviceList = () => {
        axios({
            method: "get",
            url: `/api/device/books/parent/search/${this.state.branchId}/${this.state.searchType}/${this.state.searchKeyword}`,
        })
            .then((result) => {
                if (result.data.code === 200) {
                    this.setState({ devices: result.data.devices }, () => {
                        this.setSelectedRelevantInfo(this.state.searchType, this.state.searchKeyword);
                    });
                } else {
                    if(result.data.code === Constant.RESPONSE.NOT_FOUND_ITEM.code) {
                        this.setState({ devices: null }, () => {
                            this.setSelectedRelevantInfo(this.state.searchType, this.state.searchKeyword);
                        });
                    } else {
                        console.log(result);
                        console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    }
                }
            })
            .catch((error) => {
                if(error && error.data && error.data.code === Constant.RESPONSE.NOT_FOUND_ITEM.code) {
                    this.setState({ devices: null }, () => {
                        this.setSelectedRelevantInfo(this.state.searchType, this.state.searchKeyword);
                    });
                } else {
                    console.log(error);
                    console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                }
            });
    };

    setSelectedRelevantInfo = (type, id) => {
    };

    onGridReadyHandler = () => {
        if(this.state.branchId > 0) {
            this.getNurseryList(this.state.branchId);
        } else {
            this.getBranchList();
        }
    };

    onSearchConfigChangedHandler = (searchType, searchKeyword) => {
        if (this.state.isSearchReady === false) {
            toast(
                <div>
                    <div>검색 화면 준비중입니다.</div>
                    <div>잠시만 기다려주십시오.</div>
                </div>,
                { type: toast.TYPE.ERROR }
            );
            return;
        }
        if (searchType == "branch") {
            const selectedBranch = this.state.branches.find((b) => b.id == searchKeyword);
            this.setState({selectedBranch: selectedBranch, nurseries: null, selectedDevice: null, devices: []}, () => {
                if( selectedBranch) {this.getNurseryList(selectedBranch.id); }
            });
        } else if (searchType === "nursery" && searchKeyword === "-1") {
            // searchType = "branch";
            // searchKeyword = this.state.selectedBranch.id;
            this.setState({ devices: null });
        } else {
            this.setState({ searchType: searchType, searchKeyword: searchKeyword }, () => {
                this.getDeviceList();
            });
        }
    };

    onDeviceSelected = (id) => {
        this.setSelectedRelevantInfo("device", id);
    };

    onDeviceDisconnected = () => {
        this.setState({ devices: [] }, () => {
            this.getDeviceList();
        });
    };

    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
                    <div className="row">
                        <RouteTitle title="조회 - 디바이스(동화 부모님)" />
                    </div>
                </div>
                <div className="container-fluid dashboard-content">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
                            <DeviceSearchConfig
                                branchId={this.state.branchId}
                                toast={toast}
                                branches={this.state.branches}
                                nurseries={this.state.nurseries}
                                onSearchConfigChangedHandler={this.onSearchConfigChangedHandler}
                            ></DeviceSearchConfig>
                        </div>
                    </div>

                    {/* <div className="row mb-2">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <DeviceBranchInfo selectedBranch={this.state.selectedBranch}></DeviceBranchInfo>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                            <DeviceNurseryInfo selectedNursery={this.state.selectedNursery}></DeviceNurseryInfo>
                        </div>
                    </div> */}

                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
                            <DeviceBooksParentTable
                                height={450}
                                toast={toast}
                                devices={this.state.devices}
                                onGridReadyHandler={this.onGridReadyHandler}
                                onRowSelected={this.onDeviceSelected}
                                onDeviceDisconnectedHandler={this.onDeviceDisconnected.bind(this)}
                            />
                        </div>
                    </div>
                </div>
                <ToastContainer autoClose={2000} hideProgressBar={true} transition={Slide} />
            </div>
        );
    }
}

export default SearchDeviceBooksParent;
